import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { BackendService } from '../shared/backend.service';
import { AuthService } from '../shared/auth.service';
import { AlertmessageService } from '../shared/alertmessage.service';
import { NotificationService } from '../notification.service';
import { Router } from '@angular/router';
import CONFIG from 'src/config';

@Component({
  selector: 'app-unsubsribed',
  templateUrl: './unsubsribed.component.html',
  styleUrls: ['./unsubsribed.component.scss']
})
export class UnsubsribedComponent implements OnInit {

  Unsubsribe: FormGroup;
  getEmailAddress: any;
  loadingData1: boolean = true;
  constructor(public _backendservice: BackendService,
    public _formBuilder: FormBuilder,
    public _authService: AuthService,
    public _alert: AlertmessageService,
    public _notification: NotificationService,
    public _router: Router) { }

  ngOnInit(): void {
    this.setForm();
    this.pageLoad();
  }

  pageLoad() {
    this._backendservice.getData(`${CONFIG.unsubsribeApiUrlBase}/${this._authService.NIBNumber}`)
      .subscribe(
        response => {
          //console.log(response);
          this.getEmailAddress = response['email'];
          // console.log(this.security,this.Beneficiaries,this.securitylist);
        })

  }
  Unsubsribedata(data) {
    //console.log(data)

    this._backendservice.postData(data, `${CONFIG.unsubsribeApiUrlBase}/save/${this._authService.NIBNumber}`)
      .subscribe(
        response => {
          if (response) {
            this.loadingData1 = true;
            this._notification.showNotification({ message: response['msg'], type: 'success' });
            this._router.navigate(['/login']);
            //this._alert.openConfirmationDialog(response['msg']);

          }
          else {
            ////console.log("test fail");
            this.loadingData1 = true;
            this._notification.showNotification({ message: response['msg'], type: 'error' });
          }
        });
  }
  setForm() {

    this.Unsubsribe = new FormGroup({

      Email: new FormControl('', [Validators.required]),

    });
  }
}
